export default __webpack_public_path__ + "static/Moodboard-6b1ee33cdeff6fc3df637871014318ca.png";